import { lighten } from 'polished';
import styled from 'styled-components';

export const Container = styled.div`
  padding: 2.38rem 2.38rem;
  position: relative;
  overflow-y: clip;
  overflow-x: clip;
`;

export const HeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 1.58rem;
  border-bottom: 1px solid #e2e2e2;
  > a {
    display: flex;
    align-items: center;
    width: auto;
    font-family: 'RedHatDisplay-ExtraBold';
    font-size: 1.1rem;
    opacity: 0.8;
    transition: opacity 0.3s;

    > svg {
      margin-right: 0.89rem;
      opacity: 0.8;
    }

    &:hover {
      opacity: 1;

      > svg {
        opacity: 1;
      }
    }
  }
`;

export const HeaderMainContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 1.58rem;
  margin-bottom: 1.58rem;

  > .primary-button {
    width: 13rem;
    height: 3rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
    color: #fff;
    line-height: 1.28rem;
    padding: 0.77rem 1rem;
    border-radius: 0.55rem;
    min-width: 10.57rem;
    min-height: 2.82rem;
    box-shadow: 0px 3px 6px rgba(255, 159, 0, 0.3);
  }
`;

export const TitleWrapper = styled.header`
  font-size: 1rem;
  display: flex;
  align-items: center;

  > svg {
    margin-right: 0.88rem;
  }

  h1 {
    text-align: center;
    font-family: 'RedHatDisplay-Extrabold';
    color: #1e88e5;
    font-size: 2rem;
    line-height: 2.55rem;
    margin-right: 0.88rem;
  }

  > div > svg {
    display: block;
    margin: auto;
    position: relative;
    cursor: pointer;
    transition: stroke 0.3s;
  }

  > div > svg {
    stroke: ${lighten(0.16, '#63646A')};

    &:hover {
      stroke: #63646a;
    }
  }

  p {
    font-family: 'MarkPro';
    font-size: 1rem;
    line-height: 1.44rem;
    margin-left: 1.88rem;
  }
`;

export const MainContent = styled.main`
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 2.38rem;
`;
export const SubTitlePage = styled.div`
  font-family: 'RedHatDisplay-Medium';
  display: flex;
  align-items: center;
  gap: 0.6rem;
  color: #323232;
  font-size: 1.2rem;
  line-height: 1.54rem;
`;

export const CardModalities = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
  margin-top: 1.5rem;
`;

export const CardContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  border: 1px solid #bce2be; /* Light green border */
  border-radius: 16px;
  padding: 2rem;
  width: 80%;
  font-family: 'RedHatDisplay-Medium';
  background-color: #ffffff;
  gap: 1.6rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
`;

export const ImageSection = styled.div`
  flex: 0 0 12.2rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const RobotImagePlaceholder = styled.img`
  width: 100%;
  height: auto;
  object-fit: contain;
  /* You can replace this src with the actual exported asset */
`;

export const ContentSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.6rem;
`;

export const TitleGroup = styled.div`
  display: flex;
  align-items: baseline;
  gap: 0.6rem;
`;

export const MainTitle = styled.h2`
  font-family: 'RedHatDisplay-Bold';
  color: #1e88e1; /* Blue text */
  font-size: 1.6rem;
  margin: 0;
`;

export const SubTitle = styled.span`
  color: #6b7280;
  font-size: 12px;
  font-weight: 500;
`;

export const ActionButton = styled.div`
  background-color: #ff9800; /* Orange button */
  color: #ffffff;
  border: none;
  border-radius: 20px;
  padding: 0.4rem 0.8rem;
  font-size: 0.5rem;
  font-weight: bold;
  text-transform: uppercase;
`;

export const DescriptionText = styled.p`
  color: #323232;
  font-size: 0.8rem;
  line-height: 1.5;
  margin: 0 0 0.8rem 0;
`;

export const CategoriesRow = styled.div`
  display: flex;
  gap: 0.8rem;
  margin-bottom: 0.8rem;
`;

export const CategoryBadge = styled.div`
  width: 7.65rem;
  background-color: #dbeafe; /* Light blue background */
  color: #1e88e1;
  padding: 0.4rem 0.6rem;
  border-radius: 6px;
  font-size: 0.7rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;

  h4 {
    font-family: 'RedHatDisplay-Bold';
  }
`;

export const TasksList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
`;

export const TaskItem = styled.li`
  background-color: #dcfce7; /* Light green background */
  border-radius: 0.4rem;
  padding: 0.4rem 0.6rem;
  display: flex;
  align-items: center;
  gap: 0.6rem;
`;

export const TaskNumber = styled.span`
  background-color: #fcd34d; /* Yellow circle */
  color: #b45309;
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.6rem;
  font-weight: 800;
`;

export const TaskText = styled.span`
  color: #065f46;
  font-size: 0.6rem;
`;

export const BoldText = styled.strong`
  font-weight: 700;
`;

export const SectionBot = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center; /* Centraliza verticalmente o conteúdo */
  margin-top: 1.2rem;

  /* clip corta horizontalmente sem criar scroll container,
     mantendo overflow-y: visible verdadeiro (sem barra de rolagem) */
  overflow-x: visible;
  overflow-y: visible;

  min-height: 350px;
  max-height: 600px;
  width: 100%;
  position: relative;
`;

export const FuzzyBotSection = styled.div`
  flex: 0 0 50%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 1.5rem;
  padding-right: 2rem;

  h3 {
    text-align: left;
  }

  .primary-button {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    font-size: 1rem;
    padding: 0.77rem 1rem;
    text-align: center;
    width: fit-content;
    border-radius: 8px;
  }
`;

export const ImageWrapper = styled.div`
  flex: 0 0 55%;
  align-self: stretch;
  position: relative;

  div {
    position: absolute;
    width: 100%;
    height: 500px;
  }

  img {
    position: absolute;
    top: -45%;
    left: -35%;
    width: 150%;
    height: 140%;
    margin-top: -20px;
    object-fit: cover;
    object-position: left top;
  }
`;
